// zpl.io/VxBklkJ
// zpl://screen?sid=5a849cfbfaff0fa029e9a910&pid=585bf66375444cdc15d84ca7
import { ColorLevel, ColorName, HexColor, Pallete } from './types';

export const colorPalette: Pallete = {
  brandPrimary: {
    4: { hex: '#FFF6F4', name: 'brandPrimary 4' },
    3: { hex: '#FECBC2', name: 'brandPrimary 3' },
    2: { hex: '#FE9D89', name: 'brandPrimary 2' },
    1: { hex: '#FE7C62', name: 'brandPrimary 1' },
    0: { hex: '#FE5B3B', name: 'brandPrimary 0' },
    '-1': { hex: '#BF442C', name: 'brandPrimary -1' },
    '-2': { hex: '#7F2E1E', name: 'brandPrimary -2' },
    '-3': { hex: '#632316', name: 'brandPrimary -3' },
    '-4': { hex: '#40170F', name: 'brandPrimary -3' },
  },
  white: {
    4: { hex: '#FFFFFF', name: 'white' },
    3: { hex: '#FFFFFF', name: 'white' },
    2: { hex: '#FFFFFF', name: 'white' },
    1: { hex: '#FFFFFF', name: 'white' },
    0: { hex: '#FFFFFF', name: 'white' },
    '-1': { hex: '#FFFFFF', name: 'white' },
    '-2': { hex: '#FFFFFF', name: 'white' },
    '-3': { hex: '#FFFFFF', name: 'white' },
    '-4': { hex: '#FFFFFF', name: 'white' },
  },
  gray: {
    4: { hex: '#FFFFFF', name: 'white' },
    3: { hex: '#F8F8F9', name: 'gray 3' },
    2: { hex: '#E8EEF0', name: 'gray 2' },
    1: { hex: '#CBD5DA', name: 'gray 1' },
    0: { hex: '#AFBBC3', name: 'gray 0' },
    '-1': { hex: '#97A4A9', name: 'gray -1' },
    '-2': { hex: '#5B6B70', name: 'gray -2' },
    '-3': { hex: '#293538', name: 'gray -3' },
    '-4': { hex: '#202526', name: 'black' },
  },
  red: {
    4: { hex: '#FFF0F0', name: 'red 4' },
    3: { hex: '#F8B1B1', name: 'red 3' },
    2: { hex: '#E06666', name: 'red 2' },
    1: { hex: '#E84B4B', name: 'red 1' },
    0: { hex: '#CB0000', name: 'red 0' },
    '-1': { hex: '#980000', name: 'red -1' },
    '-2': { hex: '#690E0E', name: 'red -2' },
    '-3': { hex: '#431C1C', name: 'red -3' },
    '-4': { hex: '#290C0C', name: 'red -4' },
  },
  blue: {
    4: { hex: '#EFF4FC', name: 'blue 4' },
    3: { hex: '#C3DAF9', name: 'blue 3' },
    2: { hex: '#74ABF1', name: 'blue 2' },
    1: { hex: '#468FED', name: 'blue 1' },
    0: { hex: '#1873E8', name: 'blue 0' },
    '-1': { hex: '#1256AE', name: 'blue -1' },
    '-2': { hex: '#0C3A74', name: 'blue -2' },
    '-3': { hex: '#072A55', name: 'blue -3' },
    '-4': { hex: '#061D3A', name: 'blue -4' },
  },
  yellow: {
    4: { hex: '#FFFAEE', name: 'yellow 4' },
    3: { hex: '#F7E3B5', name: 'yellow 3' },
    2: { hex: '#FACF68', name: 'yellow 2' },
    1: { hex: '#F8BF36', name: 'yellow 1' },
    0: { hex: '#F6AF04', name: 'yellow 0' },
    '-1': { hex: '#B98303', name: 'yellow -1' },
    '-2': { hex: '#7B5802', name: 'yellow -2' },
    '-3': { hex: '#523B02', name: 'yellow -3' },
    '-4': { hex: '#3E2C01', name: 'yellow -4' },
  },
  green: {
    4: { hex: '#F5FFF9', name: 'green 4' },
    3: { hex: '#C6EFD9', name: 'green 3' },
    2: { hex: '#77CEA0', name: 'green 2' },
    1: { hex: '#4ABE81', name: 'green 1' },
    0: { hex: '#1DAE61', name: 'green 0' },
    '-1': { hex: '#168349', name: 'green -1' },
    '-2': { hex: '#0F5731', name: 'green -2' },
    '-3': { hex: '#07391E', name: 'green -3' },
    '-4': { hex: '#072C18', name: 'green -4' },
  },
  orange: {
    4: { hex: '#FFF7EE', name: 'orange 4' },
    3: { hex: '#FDDFB8', name: 'orange 3' },
    2: { hex: '#FFBD66', name: 'orange 2' },
    1: { hex: '#FFA733', name: 'orange 1' },
    0: { hex: '#FF9100', name: 'orange 0' },
    '-1': { hex: '#BF6D00', name: 'orange -1' },
    '-2': { hex: '#804900', name: 'orange -2' },
    '-3': { hex: '#5A3301', name: 'orange -3' },
    '-4': { hex: '#402400', name: 'orange -4' },
  },
  purple: {
    4: { hex: '#FAFAFF', name: 'purple 4' },
    3: { hex: '#DAD8F2', name: 'purple 3' },
    2: { hex: '#B3B2DF', name: 'purple 2' },
    1: { hex: '#8989C5', name: 'purple 1' },
    0: { hex: '#6C6BB7', name: 'purple 0' },
    '-1': { hex: '#515089', name: 'purple -1' },
    '-2': { hex: '#36365C', name: 'purple -2' },
    '-3': { hex: '#28284D', name: 'purple -3' },
    '-4': { hex: '#1B1B2E', name: 'purple -4' },
  },
  aqua: {
    4: { hex: '#F5FFFD', name: 'aqua 4' },
    3: { hex: '#B8F0E6', name: 'aqua 3' },
    2: { hex: '#7EE2CF', name: 'aqua 2' },
    1: { hex: '#40C8AE', name: 'aqua 1' },
    0: { hex: '#10BA9A', name: 'aqua 0' },
    '-1': { hex: '#0C8B73', name: 'aqua -1' },
    '-2': { hex: '#085D4D', name: 'aqua -2' },
    '-3': { hex: '#044539', name: 'aqua -3' },
    '-4': { hex: '#042F27', name: 'aqua -4' },
  },
  brown: {
    4: { hex: '#FFFBF8', name: 'brown 4' },
    3: { hex: '#DECFC0', name: 'brown 3' },
    2: { hex: '#AA927A', name: 'brown 2' },
    1: { hex: '#8E6E4D', name: 'brown 1' },
    0: { hex: '#724A21', name: 'brown 0' },
    '-1': { hex: '#563819', name: 'brown -1' },
    '-2': { hex: '#392511', name: 'brown -2' },
    '-3': { hex: '#2D1F0D', name: 'brown-3' },
    '-4': { hex: '#1C1308', name: 'brown -4' },
  },
};

export const palette: Pallete = {
  alert: colorPalette.orange,
  background: colorPalette.white,
  negative: colorPalette.red,
  neutral: colorPalette.gray,
  positive: colorPalette.green,
  primary: colorPalette.blue,
  secondary: colorPalette.brandPrimary,
  warning: colorPalette.yellow,
  ...colorPalette,
};

export default function getColor(type: ColorName, value: ColorLevel = 0) {
  if (!palette[type][value]) {
    if (process.env.NODE_ENV === 'development') {
      console.error(
        `Warning: type '${type}' with value '${value}' not found, defaulting to 0`,
      );
    }

    return palette[type][0].hex;
  }

  return palette[type][value].hex;
}

export { ColorName, ColorLevel, Pallete, HexColor };
